import styled from 'styled-components';

export const Footer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
`;
